/**
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
"use strict";
import * as angular from "angular";
import * as _ from "lodash";
/* globals ChaWrap: false, A2DP_CHA: false */
/* jshint bitwise: false*/
angular
  .module("tabsint.services.cha", [])
  .factory("cha", function(chaFactory) {
    return chaFactory.createCha();
  })
  .factory("chaDosimeter", function(chaFactory) {
    return chaFactory.createDosimeter();
  });
